<ng-container [caLocalizationScope]="localizationScope">
  @if (!!(isConfigurableToggle()) && !isMobile) {
  <div class="heading-20 mb-2">{{ 'reportLayout' | caLocalize }}</div>

  <div class="d-flex mb-5">
    <f-chip
      class="me-1"
      [size]="chipSize"
      [type]="layout === ItineraryReportLayout.Standard ? ChipType.SingleChoice : ChipType.Enabled"
      [disabled]="isStandardDisabled"
      [attr.title]="isStandardDisabled ? ('standardItineraryDisabledTooltip' | caLocalize) : null"
      (chipClick)="setLayout({ id: ItineraryReportLayout.Standard })"
      data-automation-id="single-choice-chip-standard"
      >{{ 'standard' | caLocalize }}</f-chip
    >
    <f-chip
      [size]="chipSize"
      [type]="layout === ItineraryReportLayout.Configurable ? ChipType.SingleChoice : ChipType.Enabled"
      [disabled]="isConfigurableDisabled"
      [attr.title]="
        isConfigurableDisabled
          ? configurableDisableReason === 'externalParticipantLimit'
            ? ('configurableItineraryExternalParticipantLimitTooltip'
              | caLocalize : { count: externalParticipantLimit })
            : ('configurableItineraryLimitTooltip' | caLocalize : { count: activityLimit })
          : null
      "
      (chipClick)="setLayout({ id: ItineraryReportLayout.Configurable })"
      data-automation-id="single-choice-chip-configurable"
      >{{ 'configurable' | caLocalize }}</f-chip
    >
  </div>
  } @if (layout === ItineraryReportLayout.Configurable) {
  <ca-configurable-itinerary-templates
    [request]="request"
    [setAsDefaultControl]="setAsDefaultControl"
    class="h-100"
  ></ca-configurable-itinerary-templates>
  } @else{
  <div class="heading-20 mb-2 mt-2">{{ 'dataPoints' | caLocalize }}</div>
  <p class="mb-2">{{ 'itineraryReportDescription' | caLocalize }}</p>
  <form [formGroup]="form">
    <ca-itinerary-group-sections-selector
      formControlName="sections"
      (orderChange)="settingsChange($event)"
      (selectionChange)="selectionChange($event)"
    >
    </ca-itinerary-group-sections-selector>
    <ca-set-as-default-toggle
      [control]="setAsDefaultControl"
      [toggleLabel]="'itineraryToggleLabel'"
    ></ca-set-as-default-toggle>
  </form>
  }
  <ng-template fDrawerFooterTemplate>
    @let isConfigurable = layout === ItineraryReportLayout.Configurable;
    <f-inline-alert *ngIf="totalLimitReached" [type]="alertType" rootCssClass="mt-1 mb-3 d-sm-none">
      <div>
        {{ 'dataPointSelectionDisabledTooltip' | caLocalize }}
      </div>
    </f-inline-alert>
    <ca-modify-report-drawer-footer
      [isConfigurable]="isConfigurable"
      [disableSaving]="disableSaving"
      [createReportTitle]="isConfigurable ? 'create' : 'createItineraryReport'"
      (closeDrawer)="close()"
      (createReport)="createReport()"
      (previewAndCustomize)="previewAndCustomize()"
    >
    </ca-modify-report-drawer-footer>
  </ng-template>
</ng-container>
